export default {
  namespaced: true,
  state: {
    popupActive: false,
    contactFor: 1,
  },
  mutations: {
    OPEN_SOSPOPUP(state, data) {
      state.popupActive = true;
      state.contactFor = data.contactFor;
    },
    CLOSE_SOSPOPUP(state) {
      state.popupActive = false;
    },
  },
  actions: {
    openSosPopup({ commit }, data) {
      commit('OPEN_SOSPOPUP', data);
    },
    closeSosPopup({ commit }) {
      commit('CLOSE_SOSPOPUP');
    },
  },
};
